import type { AnyAppData, AppDataKey, AppDataTypes } from '@/server/app-data';
import { clearLocalStorage, getFromLocalStorage, saveToLocalStorage } from './storage';

export function isAppDataLoaded<K extends readonly AppDataKey[]>(
  appData: AnyAppData,
  keys: K
): appData is AnyAppData & Pick<AppDataTypes, K[number]> {
  if (!appData || !Object.keys(appData).length) {
    return false;
  }

  if (!keys?.length) {
    return true;
  }

  let keysLoaded = true;
  for (const key of keys) {
    if (typeof appData[key as keyof AnyAppData] === 'undefined') {
      keysLoaded = false;
      break;
    }
  }

  return keysLoaded;
}

/**
 * Reset local storage if reset key is changed.
 *
 * @param {string} resetId - reset id to be to be stored to local storage. If reset id is changed, local storage is resetted.
 * @returns {boolean} true if local storage was resetted, false otherwise
 */
export function localStorageReset(resetId: string) {
  if (!resetId) return false;

  const latestResetId = getFromLocalStorage('localStorageResetKey');

  if (resetId !== latestResetId) {
    clearLocalStorage();
    saveToLocalStorage('localStorageResetKey', resetId);
    return true;
  }

  return false;
}
